import { observer } from 'mobx-react';
import { TableColumn } from '@servicetitan/table';
import { Table } from '@servicetitan/design-system';
import { useInvariableEffect } from '@servicetitan/react-hooks';
import { provide, useDependencies } from '@servicetitan/react-ioc';
import { TABLE_PAGE_SIZE } from '../../utils/ux';
import { ActionsCell } from './cells/actions-cell';
import { PartnersStore } from '../../stores/partners.store';
import { LoadStatus } from '../../../common/enums/load-status';

export const Partners = provide({ singletons: [PartnersStore] })(
    observer(() => {
        const [{ init, partners, loadStatus }] = useDependencies(PartnersStore);

        useInvariableEffect(() => {
            init();
        });

        return (
            <Table
                pageable
                data={partners}
                striped={false}
                pageSize={TABLE_PAGE_SIZE}
                loading={loadStatus === LoadStatus.Loading}
            >
                <TableColumn field="name" title="Partner Name" />
                <TableColumn field="tenantsCount" title="Tenants" width={120} />
                <TableColumn field="configs.emailSenderDomain" title="Email Sender Domain" />
                <TableColumn
                    locked
                    field=""
                    width={110}
                    cell={ActionsCell}
                    headerCell={() => null}
                />
            </Table>
        );
    }),
);
